<template>
    <div class="child-page">
        <div class="top-header">
            <div class="user-avatar">
                <div v-if="!avatarUrl" class="ic_default"></div>
                <img v-else-if="avatarUrl.indexOf('thirdwx.qlogo.cn') > -1" :src="filterImgUrl(avatarUrl)" />
                <img v-else :src="filterImgUrl(avatarUrl)" alt="" />
                <div v-if="disableState & avatarDisable" class="upload-not">审核中</div>
                <div v-else class="upload-ic" @click="avatarClick"></div>
                <label>
                    <input type="file" ref="fileUpload" hidden id="upload" @change="uploadChange" accept="image/gif,image/jpeg,image/jpg,image/png" />
                </label>
            </div>
            <div class="info">
                <div>{{ username }}</div>
                <div class="info_txt user_id">用户ID: {{ userId }}</div>
                <div class="info_txt info_vip">VIP: {{ vipTime }}</div>
            </div>
            <div class="vip_bt" @click="vipRechargeClick">充值会员</div>
        </div>
        <div class="basic_title">基本信息</div>
        <div class="basic_row">
            <div class="title">昵称</div>
            <div class="content name-input">
                <input ref="nameinput" :disabled="nickEditDisable" v-model="nickName" maxlength="16" @change="nickInputChange" />
                <div v-if="!nickEditDisable" class="clear" @click="nameClearClick"></div>
            </div>
            <div class="bt-txt" :class="{ disabled: disableState & nickDisable }" @click="editNameClick">{{ disableState & nickDisable ? '审核中' : nickEditDisable ? '修改昵称' : '保存' }}</div>
        </div>
        <div class="basic_row">
            <div class="title">实名认证</div>
            <div class="content">
                <span :class="{ txt_yellow: !identifyAuth }">{{ identifyAuth ? '已认证' : '未认证' }}</span>
            </div>
            <div v-if="!identifyAuth" class="bt-txt" @click="authRealNameClick">实名认证</div>
        </div>
        <div class="basic_row">
            <div class="title">注册时间</div>
            <div class="content">{{ createTime }}</div>
        </div>
        <div class="basic_row">
            <div class="title">手机号</div>
            <div class="content">
                <span :class="{ txt_yellow: !mobile }">{{ mobile ? mobile : '未绑定' }}</span>
            </div>
            <div v-if="!mobile" class="bt-txt" @click="bindMobileClick">绑定手机号</div>
        </div>
    </div>
</template>
<script>
import utils from '@/utils'
import { getDictConfig } from '@/http/api/common'
import { updateInfo } from '@/http/api/user'
import { upload } from '@/http/api/upload'
import { datetime1 } from '@/utils/date.js'
import { getVipShopList } from '@/http/api/vip'

export default {
    name: 'MineCenter',
    data() {
        return {
            nickDisable: 0b0010, // 昵称审核中
            avatarDisable: 0b0001, // 头像审核中
            vipTime: '', // 会员时间
            nickEditDisable: true,
            showClearBt: false,

            nickName: '',
            avatarUrl: '',
            updateInfoSwitch: false,

            is_first: 1 // 是否首次购买
        }
    },
    computed: {
        userId: function () {
            return this.$store.state.userInfo.id
        },
        username: function () {
            const name = this.$store.state.userInfo.name,
                reg = /^1[3-9]\d{9}$/
            let displayNmae = ''
            if (reg.test(name)) {
                displayNmae = utils.formatPhoneNumber(name)
            } else {
                displayNmae = name
            }
            return displayNmae
        },
        avatar: function () {
            const avatar = this.$store.state.userInfo.avatar
            if (!avatar) {
                return ''
            } else if (avatar.indexOf('thirdwx.qlogo.cn') > -1) {
                return avatar
            } else {
                return avatar
            }
        },
        // 审核中状态
        disableState: function () {
            var desc = this.$store.state.userInfo.desc
            var state = 0b0000
            if (desc && desc != 'null') {
                try {
                    var descValue = JSON.parse(desc)
                    if (descValue.t_audit == 0) {
                        // 昵称是否在审核中
                        if (descValue.t_name) {
                            // 昵称审核中
                            state = this.nickDisable | state
                            this.nickName = descValue.t_name + ' (审核中)'
                        }
                        if (descValue.t_avatar) {
                            // 头像审核中
                            state = this.avatarDisable | state
                            this.avatarUrl = descValue.t_avatar
                        }
                    }
                } catch (err) {}
            }
            return state
        },
        // 实名认证
        identifyAuth: function () {
            return this.$store.state.authInfo.status == 1
        },
        isVip: function () {
            return this.$store.state.vipInfo.is_vip
        },
        // 手机号
        mobile: function () {
            return this.$store.state.userInfo.mobile
        },
        createTime: function () {
            return this.$store.state.userInfo.createTime
        }
    },
    watch: {
        avatar: {
            immediate: true,
            handler(val) {
                this.avatarUrl = val
            }
        },
        username: {
            immediate: true,
            handler(val) {
                this.nickName = val
            }
        },
        '$store.state.serverTime': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.vipTime = this.$Utils.showVipText()
                }
            }
        }
    },
    mounted() {
        this.getUserInfo()
        this.getVipTime()
        this.getUpdateDict()
    },
    methods: {
        filterImgUrl(value) {
            return utils.filterImgUrl(value)
        },
        // 会员充值
        vipRechargeClick() {
            this.$router.push('/vip')
        },
        avatarClick() {
            if (this.disableState & this.avatarDisable) {
                // 头像审核中、暂不支持修改
                this.$Toast.show('暂不支持修改')
            } else if (!this.updateInfoSwitch) {
                this.$Toast.show('暂不支持修改')
            } else {
                this.$refs.fileUpload.click()
            }
        },
        uploadChange(e) {
            var file = e.target.files[0]
            if (!utils.beforeUpload(file)) {
                return this.$Toast.show('请上传jpg/png/gif格式的图片')
            }
            if (file.size > 2 * 1024 * 1024) {
                return this.$Toast.show('上传的图片大小最大为2MB')
            }
            var that = this
            // 上传请求
            upload(file).then(function (res) {
                if (res.code == 0) {
                    var descValue = { t_name: '', t_avatar: '', t_audit: '' }

                    if (that.$store.state.userInfo.desc && that.$store.state.userInfo.desc != 'null') {
                        descValue = JSON.parse(that.$store.state.userInfo.desc)
                    }
                    that.avatarUrl = res.data.img

                    var data = {
                        id: that.userId,
                        desc: JSON.stringify({
                            t_name: descValue.t_audit === 0 ? descValue.t_name : '',
                            t_avatar: res.data.img,
                            t_audit: 0
                        })
                    }
                    that.updateInfo(data, function () {
                        that.getUserInfo()
                    })
                } else {
                    that.$Toast.show(res.msg)
                }
            })
        },

        /**
         * 修改昵称点击
         */
        editNameClick() {
            if (this.disableState & this.nickDisable) {
                return // 正在审核中
            }

            if (!this.updateInfoSwitch) {
                return this.$Toast.show('暂不支持修改')
            }

            if (!this.nickEditDisable) {
                this.modifyUserName()
            } else {
                this.nickEditDisable = !this.nickEditDisable
            }
        },

        nameClearClick() {
            this.nickName = ''
            this.$refs.nameinput.focus()
        },

        nickInputChange(e) {
            this.nickName = e.target.value
        },

        //实名认证点击
        authRealNameClick() {
            if (this.identifyAuth) {
                return // 已经认证了
            }
            this.$Auth.show('nothing')
        },

        // 绑定手机号点击
        bindMobileClick() {
            this.$BindMobileDialog.show()
        },

        // 修改名称
        modifyUserName() {
            var nameVal = this.nickName
            var descValue = { t_name: '', t_avatar: '', t_audit: '' }

            if (!nameVal.length) {
                return this.$Toast.show('昵称不能为空')
            } else if (nameVal.length > 16) {
                return this.$Toast.show('昵称最多为16个字符')
            }

            // 取消编辑状态
            this.nickEditDisable = !this.nickEditDisable
            var desc = this.$store.state.userInfo.desc

            if (desc && desc != 'null') {
                descValue = JSON.parse(desc)
            }

            var data = {
                id: this.userId,
                desc: JSON.stringify({
                    t_name: nameVal,
                    t_avatar: descValue.t_audit === 0 ? descValue.t_avatar : '',
                    t_audit: 0
                })
            }
            var that = this
            this.updateInfo(data, function () {
                that.getUserInfo()
            })
        },

        // 更新用户信息
        updateInfo: function (data, fn) {
            var that = this
            updateInfo(data).then(function (res) {
                if (res.code == 200) {
                    fn && fn()
                } else {
                    that.$Toast.show(res.msg)
                }
            })
        },
        // 请求用户信息 实名认证信息
        getUserInfo() {
            this.$store.dispatch('userBasicInfoAction')
            this.$store.dispatch('userVipInfoAction')
            this.$store.dispatch('userAuthInfoAction')
        },
        // 会员时间
        async getVipTime() {
            try {
                var vipGoodsRes = await getVipShopList({ page: 1, size: 100 })
                if (vipGoodsRes.code == 200) {
                    this.is_first = vipGoodsRes.data.is_first
                }
            } catch (err) {}
        },
        // 获取vip商品列表(仅仅为了获取是否是首次购买会员)
        getVipGoodsData() {
            getVipShopList(this.vipGoodsQuery).then((res) => {
                if (res.code == 200 && utils.isObject(res.data)) {
                    const { is_first, list } = res.data
                    this.is_first = is_first
                }
            })
        },
        // 是否可以修改用户信息开关配置
        getUpdateDict() {
            const query = {
                page: 1,
                size: 1,
                type: 'UPDATE_USER_INFO_SWITCH'
            }
            getDictConfig(query).then((res) => {
                if (res.code == 200 && this.$Utils.isObject(res.data) && Array.isArray(res.data.list) && res.data.list.length) {
                    if (res.data.list[0].value) {
                        this.updateInfoSwitch = true
                    }
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.child-page {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background-color: @bg-color-1E;

    padding: 40px;
    color: #fff;
    font-size: @font-size-medium;

    .top-header {
        display: flex;
        align-items: center;

        .user-avatar {
            width: 80px;
            height: 80px;
            line-height: 80px;
            border-radius: 50%;
            overflow: hidden;
            position: relative;
            background-color: #000;

            .ic_default {
                position: absolute;
                left: 50%;
                top: 50%;
                width: 100%;
                height: 100%;
                transform: translate(-50%, -50%);
                background: url(../../../assets/default.png) center no-repeat;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .upload-not {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                text-align: center;
                color: #fff;
            }

            &:hover .upload-ic {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                cursor: pointer;
                background-image: url(../../../assets/profile/profile_camera.png);
                background-repeat: no-repeat;
                background-size: 26px;
                background-position: center;
            }
        }

        .info {
            margin-left: 20px;
            min-width: 460px;

            .info_txt {
                color: @color-txt-normal;
                font-size: @font-size-normal;
                line-height: 20px;
            }

            .user_id {
                margin-top: 10px;
                user-select: text;
            }

            .info_vip {
                height: 24px;
                line-height: 26px;
                padding-left: 23px;
                background-image: url(../../../assets/ic_vip.png);
                background-size: 15px 13px;
                background-repeat: no-repeat;
                background-position-y: center;
            }
        }

        .vip_bt {
            width: 130px;
            height: 46px;
            line-height: 46px;
            border-radius: 46px;
            text-align: center;
            background: linear-gradient(125deg, #f5c86e, #fffeec);
            font-size: @font-size-large;
            color: #330000;
            cursor: pointer;
        }
    }

    .basic_title {
        margin-top: 80px;
        font-size: @font-size-large;
    }

    .basic_row {
        margin-top: 40px;
        height: 38px;
        line-height: 38px;
        display: flex;
        align-items: center;

        .title {
            width: 96px;
            font-size: @font-size-medium;
        }

        .content {
            width: 520px;
            font-size: @font-size-medium;
            color: @color-txt-normal;
            position: relative;

            input {
                height: 38px;
                line-height: 38px;
                border-radius: 19px;
                font-size: @font-size-medium;
                color: @color-txt-normal;
                background-color: #000 !important;
                border: none;
                width: 340px;
                padding: 0 50px 0 20px;

                &:focus {
                    border: none;
                    outline: none;
                }
            }

            .clear {
                position: absolute;
                top: 50%;
                margin-top: -6px;
                left: 310px;
                width: 12px;
                height: 12px;
                background: url(../../../assets/ic_x.png) center/100% no-repeat;

                &:hover {
                    cursor: pointer;
                    background: url(../../../assets/ic_x_1.png) center/100% no-repeat;
                }
            }

            .txt_yellow {
                color: @color-number-yellow2;
            }
        }

        .bt-txt {
            text-align: right;
            width: 72px;
            font-size: @font-size-normal;
            color: #24d368;
            cursor: pointer;
            text-decoration: underline;

            &:hover:not(.disabled) {
                color: #00e95b;
            }

            &.disabled {
                cursor: not-allowed;
            }
        }
    }
}
</style>
